export const MIN_LAT_VALUE = -90;
export const MAX_LAT_VALUE = 90;
export const MIN_LNG_VALUE = -180;
export const MAX_LNG_VALUE = 180;

export const MIN_UTM_VALUE = 0;
export const MAX_UTM_VALUE = 9_999_999_999;
